export default {
  name: "Workflow"
};